import React from 'react';
import dogEmpty from 'assets/dogs/dog1.png';
import { StatePanel, type StateAction } from './StatePanel';

interface Props {
    message: string;
    actions?: StateAction[];
    imageAlt?: string;
    height?: number;
}

// 空（未選択 / データ未取得）状態。既存の dog1 画像を既定に用いる。
export const EmptyState: React.FC<Props> = ({ message, actions, imageAlt = '空', height }) => (
    <StatePanel image={dogEmpty} imageAlt={imageAlt} message={message} actions={actions} height={height} />
);
